function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { StyledDynamicDevlinkComponent } from "./dynamic-devlink-component.scss.js";
import DefaultProps from "./default-props";
import { withGenericConfig } from "/contexts/generic-config-context";
import { DEVLINK_COMPONENT_CONFIGS } from "./constants/devlink-component-types";
import { EXTERNAL_SCRIPT_ID } from "./constants/external-script-constants";
import { addScriptToDOM } from "./services/external-script-service";
import { wrapTextPropsWithMarkup } from "./utils/wrap-text-props-with-markup";
import { transformImageProps } from "./utils/image-props-transformer";
import { removeEmptyProps } from "./utils/remove-empty-props";
function DynamicDevlinkComponent({ devlinkComponent }) {
    useEffect(()=>{
        addScriptToDOM();
        return ()=>{
            const script = document.getElementById(EXTERNAL_SCRIPT_ID);
            if (script) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);
    const renderDevlinkComponent = (devlinkConfig)=>{
        // Handle both old format (string) and new format (object)
        const componentType = typeof devlinkConfig === "string" ? devlinkConfig : devlinkConfig === null || devlinkConfig === void 0 ? void 0 : devlinkConfig.componentType;
        const componentConfig = DEVLINK_COMPONENT_CONFIGS[componentType];
        const Component = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.component;
        if (!Component) {
            return null;
        }
        const _ref = devlinkComponent || {}, { componentType: _ } = _ref, rest = _object_without_properties(_ref, [
            "componentType"
        ]);
        const componentKey = componentType === null || componentType === void 0 ? void 0 : componentType.toLowerCase();
        const componentProps = componentKey && rest[componentKey] ? rest[componentKey] : rest;
        // Remove empty values (null, empty strings) to allow generated default-props to apply
        const cleanedProps = removeEmptyProps(componentProps);
        // Transform nested image props to separate URL and Alt props
        const transformedProps = transformImageProps(cleanedProps);
        const wrappedProps = wrapTextPropsWithMarkup(transformedProps, componentConfig);
        // Spread generated defaults before wrapped props to ensure CMS values override defaults
        const defaultProps = (componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.defaultProps) || {};
        // Transform image objects in defaultProps to separate URL and Alt props
        const transformedDefaultProps = transformImageProps(defaultProps);
        // Also wrap defaultProps with markup so HTML strings render correctly
        const wrappedDefaultProps = wrapTextPropsWithMarkup(transformedDefaultProps, componentConfig);
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, wrappedDefaultProps, wrappedProps));
    };
    return /*#__PURE__*/ _jsx(StyledDynamicDevlinkComponent, {
        className: "dynamic-devlink-component",
        children: renderDevlinkComponent(devlinkComponent)
    });
}
DynamicDevlinkComponent.defaultProps = DefaultProps;
export default withGenericConfig(DynamicDevlinkComponent);
